import { useFormikContext } from 'formik'
import { ReactElement } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Column } from 'components/v2/Column'
import Heading from 'components/v2/Heading'
import { Row } from 'components/v2/Row'
import { IVehiclesV2FormDocumentsStepValues } from 'features/Vehicles/types'
import { FilePreview, InputFile, MB } from 'components/v2/InputFile'
import { safeFormatMessage } from '@10xlabs/utils'
import { documentsMessages } from 'features/Vehicles/messages'

export const VehicleDocumentsForm = (): ReactElement => {
  const intl = useIntl()
  const { values, setFieldValue } = useFormikContext<IVehiclesV2FormDocumentsStepValues>()

  return (
    <>
      <Heading.H4>
        <FormattedMessage id="vehicles.form.documents.title" defaultMessage="Documents" />
      </Heading.H4>
      <Row noMargin>
        {values.documents.map((document, index) => {
          const label = safeFormatMessage({ intl, messages: documentsMessages, key: document.category })

          return (
            <Column key={document.category} width="50%">
              <Heading.Label>{label}</Heading.Label>
              <InputFile
                onChange={(file): void => {
                  if (file instanceof File) {
                    setFieldValue(`documents[${index}]`, {
                      category: document.category,
                      file,
                      name: file.name,
                      path: ''
                    })
                  }
                }}
                maxSize={16 * MB}
              />
              {(document.file || document.path) && (
                <div>
                  <FilePreview file={document.file || (document.path as string)} filename={document.name} />
                </div>
              )}
            </Column>
          )
        })}
      </Row>
    </>
  )
}
